export const shouldShowTextBoxLabel = (props) =>
    props.type !== 'search' && props.label !== 'null' && props.type !== 'inlineText' && props.labelRequired !== 'no';

export const getTextInputClassName = (props) => {
    if (props.disabled) {
        return 'form-control form-control-sm border-none';
    }
    const base = props.readOnly ? props.readonlyClass : 'custom-text-box';
    const errorClass = props.error ? 'border-error-700' : '';
    return `form-control ${base}  ${errorClass} `;
};

export const getNumberInputClassName = (props) => {
    if (props.disabled) {
        return 'border-none';
    }
    const base = props.readOnly ? props.readonlyClass : 'custom-number-box';
    const errorClass = props.error ? 'border-error-700' : '';
    const labelClass = props.label === '' ? 'mt-1' : '';
    const arrowClass = props.isHideArrow ? 'hide-number-arrow' : '';
    return `form-control form-control-sm  ${base}${errorClass}
            ${labelClass} ${arrowClass}`;
};

export const getTelInputClassName = (props) =>
    `form-control form-control-sm custom-number-box ${props.error ? 'border-error-700' : ''}
              ${props.label === '' ? 'mt1' : ''}`;
